import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import React, { type SVGProps } from 'react';
const Line = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M2.38928 2.51554L253.105 2.51537" stroke="url(#paint0_linear_182_425)" strokeWidth="4" strokeLinecap="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><linearGradient id="paint0_linear_182_425" x1="2.38928" y1="2.51539" x2="255.512" y2="2.51539" gradientUnits="userSpaceOnUse"><stop offset="0.152415" stopColor="#00AE4D" stopOpacity="0" /><stop offset="1" stopColor="#00AE4D" /></linearGradient></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="255" height="5" viewBox="0 0 255 5" fill="none" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const Plane = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.05944 14.7525C7.62352 13.4156 8.35392 11.9784 9.69083 11.5425L38.7681 2.06145C40.9963 1.33492 43.3915 2.55225 44.1181 4.78043C44.2634 5.22607 44.0199 5.70512 43.5743 5.85043L11.2694 16.3839C9.93253 16.8198 8.49536 16.0894 8.05944 14.7525Z" fill="#00AE4D" />;
    t1 = <path d="M13.2575 2.53719L20.5837 9.78684L30.2383 7.31734L15.0206 0.49683C14.7572 0.378762 14.4593 0.362931 14.1848 0.452421L13.7148 0.60567C12.8875 0.875425 12.639 1.92512 13.2575 2.53719Z" fill="#00AE4D" />;
    t2 = <path d="M7.88069 10.2954L10.9115 11.2418L8.88306 15.9433L6.129 13.1939C4.83896 11.9061 6.1407 9.7521 7.88069 10.2954Z" fill="#00AE4D" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width="45" height="19" viewBox="0 0 45 19" fill="none" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
const Logo = props => {
  const $ = _c(12);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.59691 30.3103V8.03865H0.814331V0.894924H26.5738V8.03865H17.7492V30.3103H9.59691Z" fill="#00682C" />;
    t1 = <path d="M30.1522 30.3103V0.894924H44.0615C48.5578 0.894924 51.6674 2.07154 53.6425 4.04657C55.3654 5.76947 56.2478 7.99663 56.2478 10.8961V10.9802C56.2478 15.5186 53.8526 18.5021 50.1967 20.0569L57.2143 30.3103H47.8434L41.9183 21.4016H38.3045V30.3103H30.1522ZM38.3045 15.0143H43.7253C46.4567 15.0143 48.0956 13.6696 48.0956 11.5265V11.4424C48.0956 9.0892 46.3727 7.91258 43.6833 7.91258H38.3045V15.0143Z" fill="#00682C" />;
    t2 = <path d="M57.5108 30.3103L69.9913 0.684814H77.8494L90.3719 30.3103H81.6313L79.5303 25.0155H68.1423L66.0412 30.3103H57.5108ZM70.5376 18.6702H77.135L73.8573 10.3499L70.5376 18.6702Z" fill="#00682C" />;
    t3 = <path d="M98.6213 30.5204L86.7291 0.894924H95.8059L102.487 19.5106L109.211 0.894924H118.119L106.185 30.5204H98.6213Z" fill="#00682C" />;
    t4 = <path d="M120.967 30.3103V0.894924H144.625V7.78652H129.035V12.2829H143.155V18.7122H129.035V23.3767H144.836V30.3103H120.967Z" fill="#00682C" />;
    t5 = <path d="M149.036 30.3103V0.894924H157.189V23.1665H171.434V30.3103H149.036Z" fill="#00682C" />;
    t6 = <path d="M174.972 30.3103V0.894924H182.578L194.68 16.443V0.894924H202.748V30.3103H195.647L183.04 14.1739V30.3103H174.972Z" fill="#00AE4D" />;
    t7 = <path d="M207.966 30.3103V0.894924H231.624V7.78652H216.034V12.2829H230.153V18.7122H216.034V23.3767H231.834V30.3103H207.966Z" fill="#00AE4D" />;
    t8 = <path d="M236.035 30.3103V0.894924H249.944C254.441 0.894924 257.55 2.07154 259.525 4.04657C261.248 5.76947 262.131 7.99663 262.131 10.8961V10.9802C262.131 15.5186 259.735 18.5021 256.079 20.0569L263.097 30.3103H253.726L247.801 21.4016H244.187V30.3103H236.035ZM244.187 15.0143H249.608C252.34 15.0143 253.978 13.6696 253.978 11.5265V11.4424C253.978 9.0892 252.255 7.91258 249.566 7.91258H244.187V15.0143Z" fill="#00AE4D" />;
    t9 = <path d="M266.238 30.3103V0.894924H277.626C288.09 0.894924 294.183 6.94608 294.183 15.4345V15.5186C294.183 24.007 288.006 30.3103 277.458 30.3103H266.238ZM277.71 8.08067H274.391V23.0825H277.71C282.627 23.0825 285.862 20.3931 285.862 15.6446V15.5606C285.862 10.8541 282.627 8.08067 277.71 8.08067Z" fill="#00AE4D" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== props) {
    t10 = <svg xmlns="http://www.w3.org/2000/svg" width="295" height="31" viewBox="0 0 295 31" fill="none" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}</svg>;
    $[10] = props;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  return t10;
};
type Props = {
  containerClassName?: string;
  lineClassName?: string;
  planeClassName?: string;
  logoClassName?: string;
};
export const TravelNerdLogo = t0 => {
  const $ = _c(22);
  const {
    containerClassName,
    lineClassName,
    planeClassName,
    logoClassName
  } = t0;
  let t1;
  if ($[0] !== containerClassName) {
    t1 = clsx("flex", "flex-col", "gap-1", "relative", containerClassName);
    $[0] = containerClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("flex", "items-end");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== lineClassName) {
    t3 = clsx("w-64", lineClassName);
    $[3] = lineClassName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Line className={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== planeClassName) {
    t5 = clsx("w-[40px]", "h-[22px]", planeClassName);
    $[7] = planeClassName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Plane className={t5} />;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className={t2}>{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== logoClassName) {
    t8 = clsx("w-full", "h-8", "h-[32px]", logoClassName);
    $[14] = logoClassName;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Logo className={t8} />;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t1 || $[19] !== t7 || $[20] !== t9) {
    t10 = <div className={t1}>{t7}{t9}</div>;
    $[18] = t1;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};